// Store Imports
import store from "../../store";

// Action Imports
import { updateDocumentComponentAction as updateSecInDocAction } from "../../actions/DocumentActions";
import { updateDocumentComponentService as updateSecInDocService } from "../../actions/DocumentActions/services";

// Internal Imports
import { GlobalUtils } from "../../utils";

// Destructuring
const { readDataFromLocalStorage } = GlobalUtils;

export const updateSecInDocReduxAndBackend = (updatedSection, oldSection) => {
  store.dispatch(updateSecInDocAction(updatedSection));
  updateSecInDocService(updatedSection)
    .then(() => {})
    .catch(() => {
      store.dispatch(updateSecInDocAction(oldSection));
    });
};

export const isEditableTextAreaCOEditor = (
  mode,
  document,
  docRecipientList,
  isSharedDocument,
  clauseOptionsDetails,
) => {
  const {
    scope: { write, fill } = {},
    isLocked,
    stage,
    // showForm,
    // docType,
    template_type: templateType,
  } = document;
  let isEditable = false;
  if (
    mode === "DOCUMENT" &&
    // (docType === "form" || (docType === "master_form" && isSharedDocument)) &&
    clauseOptionsDetails &&
    clauseOptionsDetails.meta &&
    (clauseOptionsDetails.meta.subtype === "free_text" ||
      templateType === "editor")
  ) {
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    // For internal user
    const currentUserIsFiller = docRecipientList.some(
      item =>
        item.user &&
        item.user.id === (CURRENT_USER && CURRENT_USER.id) &&
        item.recipient_type === "FILLER",
    );

    const recipientType = clauseOptionsDetails.filler_type;
    let editableInStage = false;
    if (
      stage === "DRAFT" ||
      ((currentUserIsFiller || isSharedDocument) &&
        stage === "SENT_FOR_FILLING" &&
        recipientType === "RECIPIENT")
    ) {
      editableInStage = true;
    }
    isEditable = (!isLocked && (write || fill)) || editableInStage;
  }
  return isEditable;
};

const ALLOWED_EDITABLE_REVV_COMPONENTS = {
  HTML: true,
  Table: true,
};

export const isEditableRevvComponent = (
  type,
  mode,
  document,
  docRecipientList,
  isSharedDocument,
  clauseOptionsDetails,
) => {
  const { scope: { write, fill } = {}, isLocked, stage } = document;
  let isEditable = false;
  if (
    ALLOWED_EDITABLE_REVV_COMPONENTS[type] &&
    mode === "DOCUMENT" &&
    clauseOptionsDetails
  ) {
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    // For internal user
    const currentUserIsFiller = docRecipientList.some(
      item =>
        item.user &&
        item.user.id === CURRENT_USER.id &&
        item.recipient_type === "FILLER",
    );

    const recipientType = clauseOptionsDetails.filler_type;
    let editableInStage = false;
    if (
      stage === "DRAFT" ||
      ((currentUserIsFiller || isSharedDocument) &&
        stage === "SENT_FOR_FILLING" &&
        recipientType === "RECIPIENT")
    ) {
      editableInStage = true;
    }
    isEditable = (!isLocked && (write || fill)) || editableInStage;
  }
  return isEditable;
};
